import type { CustomAttributeV2Fragment } from '~~/lib/Shop/generated/schema';

export type CustomAttributeV2_AttributeValue_Fragment = {
  __typename: 'AttributeValue';
  value: string;
  code: string;
  label: string;
  attribute_type: string | null;
};

export function isBooleanValue(
  p: CustomAttributeV2Fragment | undefined
): p is CustomAttributeV2_AttributeValue_Fragment {
  return Boolean(
    p &&
    p.attribute_type === 'boolean' &&
    'value' in p &&
    typeof (p as { value?: unknown }).value === 'string'
  );
}
